import { render, staticRenderFns } from "./token-varification.vue?vue&type=template&id=98f144aa&"
import script from "./token-varification.vue?vue&type=script&lang=js&"
export * from "./token-varification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports